import React, { Component } from 'react'
import styled from 'styled-components'
import { XXMText, Circle } from './StyledComponents'
const StyledCirle = styled(Circle)`
  position: absolute;
  left: 5px;
`
const Div = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 4px;
  position: relative;
`
const Triangle = styled.div`
  border-top: 8px solid transparent;
  border-bottom: 8px solid transparent;
  border-right: 9px solid #56cb00;
`
const Wrap = styled.div`
  background: #56cb00;
  padding: 0 2px;
  display: flex;
  align-items: center;
  justify-content: center;
`
class Sale extends Component {
  state = {}
  render() {
    return (
      <Div>
        <Triangle />
        <StyledCirle size="3px" />
        <Wrap>
          <XXMText color="#fff">Sale</XXMText>
        </Wrap>
      </Div>
    )
  }
}

export default Sale



// WEBPACK FOOTER //
// ./src/components/Sale.js